import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import AddIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import swal from "sweetalert";

import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import { Table } from "antd";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import "./style/TreatmentPreferences.css";
import axios from "axios";
import { useRef } from "react";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export default function TreatmentPreferences(props) {
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [fieldsData, setFieldsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [moduleName, setModuleName] = useState("Treatment Preferences");
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("Treatment Preferences");
  const [moduleData, setModuleData] = useState([]);
  const [tableData, setTableData] = useState({
    uploadDocumentCarePlanData: [],
  });
  const [toUpdate, setToUpdate] = useState(false);
  const inputFileRef = useRef(null);

  const getAttribute = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(moduleName);
      if (res) {
        res.attributes &&
          res.attributes.map((attribute) => {
            setLoading(false);
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  console.log("fields", fields);
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
    } catch (error) {}
  };
  const fetchData = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setToUpdate(true);
    } catch (error) {
      console.log(error);
    } finally {
      setFormData(null);
    }
  };
  // Helper to format key names dynamically
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const moduleNames = ["Treatment Preferences", "Upload Document Care Plan"];
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const treatmentmod = results.find((item) => item.moduleName === "Treatment Preferences");
      if (treatmentmod) {
        const targetRecord = treatmentmod.records.find(
          (record) => record.subType === "Disability" || "Alternative Medicine Preferences" in record
        );
        setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }

      // Build table data object dynamically
      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("tableData", tableData);

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const uploadDocCols = [
    {
      title: "Link",
      dataIndex: "Document Upload",
      key: "Document Upload",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a style={{ color: "#7d8fb3" }} href={record["Document Upload"]} target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        window.open(record["Document Upload"]);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const deleteRecord = async (record) => {
    try {
      console.log("record", record);
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      let objToSubmit = {
        "Document Upload": res,
        "Uploaded File Name": name,
      };
      handleSubmit(objToSubmit);
    }
    inputFileRef.current.value = null;
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.addAsset(moduleName, {
        clientModules: [body],
      });
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAttribute(props.activeStep.name);
    fetchAllModulesData();
  }, []);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);

  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);
  console.log("formData", formData);
  return (
    <>
      <div className="daily-living-preferences-container">
        <div className="daily-living-preferences-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="daily-living-preferences-title">Treatment Preferences</h2>
          <ToolTipCreator name={"Disability_Treatment_Preferences"}/>
        </div>
        </div>
        {/* <div className="daily-living-preferences-help-icon-container">
          <img src={helpIcon} alt="help-icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>

      <div className="input-fields-container">
        {tabs.length > 0 && (
          <>
            <DisabilityFormCreator
              data={fields["Treatment Preferences"]}
              values={fieldsData}
              setSubmitBody={setFormData}
            />
          </>
        )}
        <NewLoader isLoading={loading} />
        {fields && (
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={() => {
                if (toUpdate) {
                  updateRecord();
                } else {
                  createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        )}
      </div>

      <div className="daily-living-preferences-container">
        <div className="daily-living-preferences-title-container">
          <h2 className="daily-living-preferences-title">Care Plan</h2>
        </div>
        <div className="daily-living-preferences-help-icon-container">
          <img src={helpIcon} alt="help-icon" width="18.67px" height="18.67px" />
        </div>
      </div>
      <div className="upload-document-container">
        <div className="upload-document-header-container">
          <div className="upload-document-title-container">
            <h2 className="upload-document-title">Upload Document</h2>
          </div>
          <div className="upload-document-add-icon-container">
            <label
              htmlFor="UploadDocumentCarePlan"
              onClick={() => {
                setModuleName("Upload Document Care Plan");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              <img src={AddIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              ref={inputFileRef}
              type="file"
              id="UploadDocumentCarePlan"
              hidden
              onChange={async (event) => {
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>
        <div className="upload-document-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.uploadDocumentCarePlanData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </>
  );
}
